<template>
  <div
    style="background-color: #fff;position: fixed;z-index: 111;;width: 100vw;height: 100vh;overflow-y: auto;top: 0;left: 0;">
    <div>
      <van-nav-bar title="订单确认" fixed left-arrow @click-left="onClickLeft" class="nav-bar">
        <template #left>
          <van-icon name="arrow-left" size="22" color="#fff" />
        </template>
      </van-nav-bar>
    </div>
    <div class="pop_container">
      <div class="title">服务详情</div>
      <div class="girlInfo">
        <div class="avatar"><img
            :src="infodata.img_url[0]" alt=""></div>
        <div class="info">
          <p class="customizedColor717">{{infodata.xuanfei_name}}</p>
          <p>{{infodata.age}}岁 &nbsp;{{infodata.hight}}CM &nbsp;<span>{{infodata.bust}}罩杯</span> &nbsp;{{infodata.class_name}} &nbsp;{{infodata.address}}</p>
        </div>
      </div>
      <hr>
      <div class="title">温馨提示</div>
      <p>如下单过程中遇到任何问题，可联系24小时充值客服反馈。我们将为您解决一切问题。</p>
      <hr>
      <div class="title">上门确认</div>
      <p>请联系上级接待</p>
      <img src="/img/infobg1.png" style="width:100%">
    </div>
    <div style="padding-bottom: 20vw; background-color: transparent;"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
    };
  },
  props:['infodata'],
  methods: {
    onClickLeft() {
      this.$emit('close')
    },
  },
};
</script>

<style scoped lang="less">
/deep/ .van-tabs__nav {
  background: rgb(172, 98, 204);
}

/deep/ .van-nav-bar__title {
  color: #333 !important;
}

.van-nav-bar {
  background: rgb(172, 98, 204);
  border-bottom-width: 0;
}

.pop_container {
  padding: 120px 34px 34px 34px;
}
.pop_container p {
  color: #000;
  font-size: 24px;
  padding-bottom: 30px;
}
.pop_container hr {
  border-color: #333333;
}
.pop_container .girlInfo {
  display: flex;
  position: relative;
  padding-bottom: 34px;
}
.pop_container .girlInfo .avatar {
  width: 102px;
  height: 102px;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
  position: relative;
}
.pop_container .girlInfo .avatar img:first-child {
  width: 100px;
  height: 100px;
  border-radius: 20px;
  border: 2px solid #ff8395;
}
.pop_container .girlInfo .info {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
}
.pop_container .girlInfo .info p:nth-child(1) {
  font-size: 24px;
  color: #000;
  font-weight: 500;
  position: relative;
  display: inline-block;
  padding-left: 140px;
  padding-bottom: 0;
  &:before {
    content: '';
    display: block;
    width: 3.125rem;
    height: 1.0625rem;
    border-top-left-radius: 0.3125rem;
    border-bottom-right-radius: 0.3125rem;
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAATCAYAAACdkl3yAAAAAXNSR0IArs4c6QAAAWBJREFUOE+d1DFLw0AUB/D/K+qkm1/BwY9QRJAawcWpiNhacHFzEDcRmgsubuLgJqjgxYogOCmYdO0sQhEnB6kguIgurfYvKQRCvKRp33b3Hr97xz1OnLJFxIP4sl1vIrrtrFpFCGoQjMTKf4HusqiydSNAAcB4pODD1t5kuE5BQLCitH8uQbFTtpoApk2QU1qoQHgKIGfofNt2vYNgP4SeAUzFIVUqrIvkTv4BAAjsK+3thLkEiK+k7IrgzIiQx8r1N6K5JKgDyKgZwbVyvWI8l3Q1kwGQDXbe5tRVsz00RLAJjOWVvv00nZKtI/KF3dyMqt23zK0mv1q0/p0/nFWXfvCyidGvo28B8lXtPaYhaXMUTEqHXS6qi3q9H5IOkWu26+ssSDJEbtmuf5gVMUPknu361UEQA8QjW/ubgyIRaP6JkAelvZVhkBAK/qQ7tFtLptHPCgsB6Q1T72cYPv4A5f+jg+8hIOgAAAAASUVORK5CYII=), -webkit-linear-gradient(#ff556e, #ff8395);
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAATCAYAAACdkl3yAAAAAXNSR0IArs4c6QAAAWBJREFUOE+d1DFLw0AUB/D/K+qkm1/BwY9QRJAawcWpiNhacHFzEDcRmgsubuLgJqjgxYogOCmYdO0sQhEnB6kguIgurfYvKQRCvKRp33b3Hr97xz1OnLJFxIP4sl1vIrrtrFpFCGoQjMTKf4HusqiydSNAAcB4pODD1t5kuE5BQLCitH8uQbFTtpoApk2QU1qoQHgKIGfofNt2vYNgP4SeAUzFIVUqrIvkTv4BAAjsK+3thLkEiK+k7IrgzIiQx8r1N6K5JKgDyKgZwbVyvWI8l3Q1kwGQDXbe5tRVsz00RLAJjOWVvv00nZKtI/KF3dyMqt23zK0mv1q0/p0/nFWXfvCyidGvo28B8lXtPaYhaXMUTEqHXS6qi3q9H5IOkWu26+ssSDJEbtmuf5gVMUPknu361UEQA8QjW/ubgyIRaP6JkAelvZVhkBAK/qQ7tFtLptHPCgsB6Q1T72cYPv4A5f+jg+8hIOgAAAAASUVORK5CYII=), linear-gradient(#ff556e, #ff8395);
    background-repeat: no-repeat, no-repeat;
    background-size: 0.5625rem 0.59375rem, cover;
    background-position: 0.625rem center, 0 0;
    position: absolute;
    left: 0.75rem;
    top: 0.0625rem;
}
&:after {
    content: '\8BA4\8BC1';
    font-weight: bold;
    font-family: PingFang SC;
    color: #000;
    font-size: 24px;
    position: absolute;
    left: 2rem;
}
}
.pop_container .girlInfo .info p.customizedColor717:before {
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAATCAYAAACdkl3yAAAAAXNSR0IArs4c6QAAAWBJREFUOE+d1DFLw0AUB/D/K+qkm1/BwY9QRJAawcWpiNhacHFzEDcRmgsubuLgJqjgxYogOCmYdO0sQhEnB6kguIgurfYvKQRCvKRp33b3Hr97xz1OnLJFxIP4sl1vIrrtrFpFCGoQjMTKf4HusqiydSNAAcB4pODD1t5kuE5BQLCitH8uQbFTtpoApk2QU1qoQHgKIGfofNt2vYNgP4SeAUzFIVUqrIvkTv4BAAjsK+3thLkEiK+k7IrgzIiQx8r1N6K5JKgDyKgZwbVyvWI8l3Q1kwGQDXbe5tRVsz00RLAJjOWVvv00nZKtI/KF3dyMqt23zK0mv1q0/p0/nFWXfvCyidGvo28B8lXtPaYhaXMUTEqHXS6qi3q9H5IOkWu26+ssSDJEbtmuf5gVMUPknu361UEQA8QjW/ubgyIRaP6JkAelvZVhkBAK/qQ7tFtLptHPCgsB6Q1T72cYPv4A5f+jg+8hIOgAAAAASUVORK5CYII=), -webkit-linear-gradient(#ac62cc, #ac62cc);
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAATCAYAAACdkl3yAAAAAXNSR0IArs4c6QAAAWBJREFUOE+d1DFLw0AUB/D/K+qkm1/BwY9QRJAawcWpiNhacHFzEDcRmgsubuLgJqjgxYogOCmYdO0sQhEnB6kguIgurfYvKQRCvKRp33b3Hr97xz1OnLJFxIP4sl1vIrrtrFpFCGoQjMTKf4HusqiydSNAAcB4pODD1t5kuE5BQLCitH8uQbFTtpoApk2QU1qoQHgKIGfofNt2vYNgP4SeAUzFIVUqrIvkTv4BAAjsK+3thLkEiK+k7IrgzIiQx8r1N6K5JKgDyKgZwbVyvWI8l3Q1kwGQDXbe5tRVsz00RLAJjOWVvv00nZKtI/KF3dyMqt23zK0mv1q0/p0/nFWXfvCyidGvo28B8lXtPaYhaXMUTEqHXS6qi3q9H5IOkWu26+ssSDJEbtmuf5gVMUPknu361UEQA8QjW/ubgyIRaP6JkAelvZVhkBAK/qQ7tFtLptHPCgsB6Q1T72cYPv4A5f+jg+8hIOgAAAAASUVORK5CYII=), linear-gradient(#ac62cc, #ac62cc);
}
.pop_container .girlInfo .info p:nth-child(2) {
    font-size: 24px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #000;
    padding-left: 24px;
    margin-top: 4px;
    padding-bottom: 0;
}

.pop_container .title {
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #262626;
  padding: 34px 40px;
  background: url(/img/xin.png) no-repeat;
  background-size: 28px 26px;
  background-position: 0 center;
}

</style>
